import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class DateFormatService {
	private readonly locale = 'es-AR';
	private readonly defaultTimeZone = 'America/Argentina/Buenos_Aires';

	toISOString(date: Date) {
		const fechaParseada = new Date(date);
		const fechaFormateada = fechaParseada.toISOString();
		return fechaFormateada;
	}

	setEndHourOfDay(date: Date): Date {
		date.setHours(23, 59, 59, 999);
		return date;
	}

	toLocaleString(date: Date | string) {
		if (typeof date === 'string') {
			return date;
		}
		const utcDate = new Date(date);
		return utcDate.toISOString();
	}

	convertUtcToLocalFormattedWithTime(
		utcDateString: string | Date,
		timeZone: string | null = this.defaultTimeZone
	): string {
		const utcDate = this.parseDateInput(utcDateString);

		const options: Intl.DateTimeFormatOptions = {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			hour12: false,
			...(timeZone ? { timeZone } : {})
		};

		const formatter = new Intl.DateTimeFormat(this.locale, options);
		const formattedDate = formatter.format(utcDate);

		return formattedDate.replace(',', ' -');
	}

	convertUtcToLocalFormatted(
		utcDateString: string | Date,
		locale: string = this.locale,
		separator: string = '-',
		timeZone: string | null = this.defaultTimeZone
	): string {
		const utcDate = this.parseDateInput(utcDateString);

		const options: Intl.DateTimeFormatOptions = {
			year: 'numeric',
			month: '2-digit',
			day: '2-digit',
			...(timeZone ? { timeZone } : {})
		};

		const formatter = new Intl.DateTimeFormat(locale, options);
		const formattedDate = formatter.format(utcDate);

		return formattedDate.replace(',', ' -').replace('-', separator);
	}

	formatLocalized(
		value: any,
		pattern = 'mediumDate',
		timeZone: string | null = null
	): any {
		const datePipe: DatePipe = new DatePipe(this.locale, timeZone ?? undefined);
		return datePipe.transform(value, pattern);
	}

	toDateOnly(
		value: any,
		timeZone: string | null = this.defaultTimeZone
	): string | null {
		return this.formatLocalized(value, 'yyyy-MM-dd', timeZone);
	}

	private parseDateInput(value: string | Date): Date {
		if (value instanceof Date) {
			return value;
		}

		const trimmed = value.trim();
		if (this.hasTimeZoneInfo(trimmed)) {
			return new Date(trimmed);
		}

		const normalized = trimmed.includes('T')
			? trimmed
			: trimmed.replace(' ', 'T');
		return new Date(`${normalized}Z`);
	}

	private hasTimeZoneInfo(value: string): boolean {
		return (
			value.endsWith('Z') ||
			/[+-]\d{2}:?\d{2}$/.test(value) ||
			value.includes('GMT')
		);
	}
}
